// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"8cf7ea4c","144":"3f05bead","787":"8a7017d4","942":"9e3a085f","951":"6da8fdf4"}[chunkId] + ".chunk.js";
};